import { FormRoot, FormRootError } from './form';

/**
 * `Form` — the form-level companion to `FormField`. `useZodForm` builds the
 * typed RHF instance from a Zod schema, `Form` provides it and handles submit:
 *
 * ```tsx
 * const schema = z.object({ email: z.email() });
 *
 * function InviteForm() {
 *   const form = useZodForm(schema, { defaultValues: { email: '' } });
 *   return (
 *     <Form form={form} onSubmit={(values) => mutation.mutate(values)}>
 *       <FormField name="email">
 *         <FormField.Label>Email</FormField.Label>
 *         <FormField.Input type="email" />
 *         <FormField.Message />
 *       </FormField>
 *       <Form.RootError />
 *       <Button type="submit">Invite</Button>
 *     </Form>
 *   );
 * }
 * ```
 */
export const Form = Object.assign(FormRoot, {
  RootError: FormRootError,
});

export type { FormProps } from './form';
export { useZodForm } from './use-zod-form';
